<template>
  <div class="hidescroll" v-if='show==true'>
    <div class="container1 q-py-lg q-mx-md q-mt-md">
      <div class="row">
        <div
          class="col-lg-3 left-panel"
          v-if="is_left_open && connectButtonVisible"
        >
          <div class="image1">
            <img class="lady-img" src="../../assets/lady-input.webp" />
          </div>
          <div class="content">
            <h6 class="text-center q-my-sm">Select Market Place Region</h6>
            <p class="text-center q-mb-lg connect">
              ( Connect your Amazon Seller Account here )
            </p>
            <div class="region-box text-center row">
              <input
                type="radio"
                value="selected"
                id="region"
                class="col-3 radio-btn"
                checked
              />
              <label for="region" class="label-region col-8"
                >India Region</label
              >
            </div>
            <div class="connect-now text-center q-pa-sm" :style="connect_now">
              <a :href="seller_api_URL">{{ connected }}</a>
            </div>
            <div class="note text-center">
              <p>
                Note: This will give permission to connect with uniQin's Price
                Prophet to access your Amazon Seller Account
              </p>
            </div>
          </div>
        </div>
        <div
          class="panel"
          :class="{ 'col-lg-9': colWidth, 'col-lg-12': !colWidth }"
        >
          <q-tabs v-model="tab" indicator-color="transparent" align="left">
            <q-tab name="app"
              style=""
              @click="
                is_left_open = true;
                colWidth = true;
              "
              
            >
              <div
                class="amazon-header text-center"
                :class="is_left_open ? 'active-header' : 'passive-header'"
                @click="repricer"
                
              >
                Repricer
              </div>
            </q-tab>
          </q-tabs>
          <div class="right-panel">
            <div class="back-shadow"></div>
            <q-tab-panels v-model="tab" animated>
              <q-tab-panel name="app">
                <div class="hide-panel" :style="hide_panel">
                  <div class="amazon-panel q-px-md q-pb-md">
                    <h4>Hello! Your Seller Account is now connected</h4>
                    <!-- <h4 class="price-prophet">Price Prophet</h4> -->
                    <button
                      class="refresh_button"
                      @click="refresh_asins()"
                      id="refresh"
                    >
                      Refresh
                    </button>
                    <!-- <router-link to="/refresh_asinlist"></router-link> -->
                  </div>
                  <div class="amazon-con">
                    <q-table
                      ref="table"
                      class="my-sticky-virtscroll-table"
                      virtual-scroll
                      :table-style="'width: 100%'"
                      :table-class="'table-scrollable'"
                      :data="data[0]"
                      :columns="columns"
                      row-key="variant"
                      :virtual-scroll-sticky-size-start="55"
                      selection="multiple"
                      :selected.sync="selected"
                      no-data-label="No Result Found"
                      :pagination.sync="pagination"
                    >
                      <template v-slot:top-right>
                        <q-input
                          dense
                          debounce="300"
                          placeholder="Search for ASINs"
                          v-model="filter"
                          @input="
                            (val) => {
                              searchHandler(val);
                            }
                          "
                        >
                          <q-icon slot="append" name="search" />
                        </q-input>
                      </template>
                      <template v-slot:header="props">
                        <q-tr :props="props">
                          
                          <q-th
                            key="asin"
                            :props="props"
                            class="headerText"
                            :style="{ fontSize: '15px', color: 'dodgerblue' }"
                          >
                            ASIN
                          </q-th>
                          <q-th
                            key="product"
                            :props="props"
                            class="headerText"
                            :style="{ fontSize: '15px', color: 'dodgerblue' }"
                          >
                            Product Name
                          </q-th>
                          <!-- <q-th
                            key="test"
                            :props="props"
                            class="headerText"
                            :style="{ fontSize: '15px', color: 'dodgerblue',textAlign: 'center' }"
                          >
                            Test
                          </q-th> -->
                          <q-th
                            key="test2"
                            :props="props"
                            class="headerText"
                            :style="{ fontSize: '15px', color: 'dodgerblue',textAlign: 'center' }"
                          >
                            Reprice/Revert
                          </q-th>
                          
                        </q-tr>
                      </template>
                      <template v-slot:body="props">
                        <q-tr :props="props">
                          <q-td key="asin" :props="props">
                            {{ props.row.asin }}
                          </q-td>

                          <q-td key="product" :props="props">
                            {{ props.row.prod_name }}
                          </q-td>
                          <!-- <q-td key="test" :props="props">
                            {{ props.row.price_limit.upper_price }}
                          </q-td> -->
                          
                          <q-td>
                            <q-btn
                            
                            color="colorbutton"
                            class="btn"
                            @click="reprice(props.row)"
                            >REPRICE</q-btn
                          >
                          <q-btn
                            
                            color="colorbutton"
                            class="btn q-ml-sm"
                            @click="revert(item)"
                            >REVERT</q-btn
                          >
                            <q-dialog v-model="repricing1">
                            <q-card class="repricecard">
                              <div>
                                <div class="back">
                                  <q-btn
                                    class="closeicon"
                                    icon="close"
                                    flat
                                    round
                                    dense
                                    v-close-popup
                                  ></q-btn>
                                </div>
                                <q-card-section>
                                  <div class="row">
                                    <div class="col-10 diahead">
                                      REPRICE SUGGESTION
                                    </div>
                                  </div>
                                </q-card-section>
                                <q-card-section class="card-sec">
                                  <div class="row name">
                                    <div class="col-6">
                                      <label
                                        ><b>Current Selling Price</b></label
                                      >
                                      <input
                                        type="text"
                                        class="inputfield-text"
                                        id="inputfield-text"
                                        v-model="currentPrice"
                                      />
                                    </div>
                                    
                                  </div>
                                  <div class="row name">
                                    <div class="col-6">
                                      <label><b>Update Selling Price</b></label>
                                    </div>
                                  </div>
                                  <div class="row name">
                                    <div class="curr">
                                      <label>{{ currency }}</label>
                                    </div>
                                    <div>
                                      <input
                                        type="number"
                                        class="inputfield-number2"
                                        id="inputfield-number"
                                        v-model="accepting_price"

                                        v-on:change="handleSaveChange"
                                      />
                                    </div>
                                    <div class="divsn q-mt-md">
                                      <q-btn
                                        class="submit"
                                        @click="repriceSubmit(repricingRow)"
                                        label="Update"
                                      >
                                      </q-btn>
                                    </div>
                                  </div>
                                  <div class="row name">
                                    <div
                                      class="col-6"
                                      style="color: #ff0000; font-size: 12px"
                                      v-if="errors == true"
                                    >
                                      <label>Please enter a valid number</label>
                                    </div>
                                  </div>
                                  <div class="text-center">
                                    <p class="note2">
                                      Note: Repricing takes 2 - 3 hours to reflect in Amazon
                                    </p>
                                  </div>
                                  
                                </q-card-section>
                              </div>
                            </q-card>
                          </q-dialog>
                          <q-dialog v-model="revert1" persistent>
                        <q-card>
                          <q-card-section class="row items-center">
                            <span class="q-ml-sm"
                              >This action will revert the price back to
                              previous selling price :
                              {{ currentPrice1 }} INR.</span
                            >
                          </q-card-section>
                          <q-card-actions align="right">
                            <q-btn
                              flat
                              label="Cancel"
                              color="primary"
                              v-close-popup
                            ></q-btn>
                            <q-btn
                              flat
                              label="Ok, Revert"
                              color="primary"
                              @click="revertSubmit(props.row)"
                            ></q-btn>
                          </q-card-actions>
                        </q-card>
                      </q-dialog>

                          </q-td>
                        </q-tr>
                      </template>
                    </q-table>
                    
                  </div>
                </div>
              </q-tab-panel>
              
            </q-tab-panels>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

body {
  font-family: "Montserrat", sans-serif;
}
.hidescroll {
  overflow-x: hidden;
}

.selectWrapper {
  display: flex;
  background: white;
  -moz-column-gap: 1rem;
  column-gap: 3rem;
  align-items: center;
  padding: 1rem;
  border-radius: 10px;
  width: 59%;
  height: 3rem;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  margin-top: 1.2rem;
}

ul > li {
  padding: 1rem;
}

ul > li:hover {
  background: grey;
}

.select-arrow {
  border: solid black;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 7.5px 9px 7.5px;
  border-color: transparent transparent #4a4946 transparent;
  display: inline-block;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.select-wrapper {
  position: relative;
  margin-left: auto;
}

.select-options {
  position: absolute;
  top: 131%;
  right: -17px;
  z-index: 1;
  background-color: white;
  border-radius: 10px;
  padding: 0;
  margin: 0;
  list-style: none;
  width: 317px;
  text-align: center;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1607843137);
}

.open .select-arrow {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
.hidescroll {
  overflow-x: hidden;
}

.selectWrapper {
  display: flex;
  background: white;
  column-gap: 1rem;
  align-items: center;
  padding: 1rem;
  border-radius: 10px;
  width: 20%;
  box-shadow: 0px 3px 6px #00000029;
}

ul > li {
  padding: 1rem;
}

ul > li:hover {
  background: grey;
}

.select-arrow {
  border: solid black;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 7.5px 9px 7.5px;
  border-color: transparent transparent #4a4946 transparent;
  display: inline-block;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.select-wrapper {
  position: relative;
  margin-left: auto;
}

.select-options {
  position: absolute;
  top: 131%;
  right: -17px;
  z-index: 1;
  background-color: white;
  border-radius: 10px;
  padding: 0;
  margin: 0;
  list-style: none;
  width: 317px;
  text-align: center;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1607843137);
}

.open .select-arrow {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}

.content {
  padding: 5px;
  margin: 0px;
}

.lady-img {
  object-fit: cover;
  width: 100%;
  height: auto;
}

.content h6 {
  color: #0c60bb;
}

.connect {
  font-weight: 500;
}

.region-box {
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  padding: 10px;
  border-radius: 5px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 30px;
}

.label-region {
  letter-spacing: 1px;
  color: #102689;
  font-weight: 600;
  font-size: 17px;
}

.connect-now {
  letter-spacing: 1px;
  color: white;
  font-weight: 600;
  font-size: 17px;
  background-color: #102689;
  border-radius: 25px;
  margin: 0px 55px 25px 55px;
}

.connect-now a {
  color: white;
}

.note {
  font-weight: 500;
  color: rgb(247, 30, 30);
}

.note1 {
  font-weight: 500;
  color: rgb(247, 30, 30);
  margin-top: 2rem;
  margin-right: 15rem;
  font-size: 15px;
}

.note2 {
  text-align: center;
  font: normal normal bold 16px/19px Montserrat;
  letter-spacing: 0px;
  color: #ff0a0a;
  opacity: 1;
  margin-top: 35px;
}

.left-panel {
  z-index: 100;
  height: 674px;
  background-color: white;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
}

.panel {
  z-index: 100;
}

.right-panel {
  width: 132%;
  position: relative;
  height: 620px;
  background-color: white;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
  top: -4px;
  overflow: scroll;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;

  /* IE 10+ */
  &::-webkit-scrollbar {
    background: transparent;
    /* Chrome/Safari/Webkit */
    width: 0px;
  }
}

/* 
.amazon-header{
    letter-spacing: 1px;
    color:white;
    font-weight: 600;
    font-size: 18px;
    background-color: #102689;
    padding: 10px 10px;
    width: 320px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
} */
.amazon-header {
  letter-spacing: 1px;
  font-weight: 600;
  font-size: 18px;
  padding: 10px 20px;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
}

.active-header {
  color: white;
  background-color: #102689;
  border: 3px solid #102689;
  border-bottom: none;
}

.passive-header {
  color: #b6b4c3;
  background-color: #f7f4f4;
  border: 3px dashed #b6b4c3;
  border-bottom: none;
}

.amazon-panel h4 {
  font-size: 28px;
  color: #160637;
  font-weight: 500;
  letter-spacing: 1px;
}

.amazon-panel .price-prophet {
  width: 230px;
  border-bottom: 3px solid rgb(151, 151, 151);
  padding-bottom: 5px;
}

.amazon_price {
  margin-bottom: 0px;
  margin-top: 2px;
  letter-spacing: 0.8px;
  font-weight: 500;
  font-size: 16px;
}

input.checkbox {
  height: 20px;
  width: 20px;
}

input.radio-btn {
  height: 22px;
  width: 22px;
  margin: 2px 10px;
}

.back-shadow {
  position: absolute;
  width: 300px;
  height: 560px;
  background-color: rgb(207, 207, 207);
  transform: rotate(-4deg);
  z-index: -10;
  right: 0px;
  top: -10px;
}

.card-sec {
  background: #f2f6ffad 0% 0% no-repeat padding-box;
  border: 2px dashed #cfcfcf;
  border-radius: 20px;
  margin-left: 19px;
  margin-right: 19px;
  border-bottom: 10 dashed #cfcfcf !important;
}

.q-field__native {
  height: 50px !important;
}

.submit_asin {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
}

.tool-tip {
  margin-top: 10px;
  font-size: 14px !important;
  font-weight: 500;
  color: rgb(247, 30, 30);
}

.back {
  width: 54px;
  height: 49px;
  /* UI Properties */
  background: #ff0000 0% 0% no-repeat padding-box;
  border-radius: 0px 20px 0px 0px;
  opacity: 1;
  margin-left: 506px;
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
}

.closeicon {
  background: #ff0000;
  color: white;
  position: absolute;
  border: 2px solid #ffffff;
}

.diahead {
  font: normal normal bold 26px/28px Montserrat;
  letter-spacing: 1.4px;
  color: #3483e2;
  text-transform: uppercase;
  opacity: 1;
  margin-top: -39px;
}

.name {
  text-align: left;
  font: normal normal normal 16px/20px;
  letter-spacing: 0px;
  color: #0c1125;
  opacity: 1;
  margin-left: 25px;
}

.repricecard {
  width: 757px;
  height: 410px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 99px #a2cff25c;
  border-radius: 20px;
  opacity: 1;
}

.q-card > div:last-child,
.q-card > img:last-child {
  border-bottom: 10 !important;
}
.inputfield-number {
  background: #f1f2f6 0% 0% no-repeat padding-box;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  opacity: 1;
  margin-bottom: 25px;
  margin-top: 10px;
  width: 200px;
  height: 36px;
  padding-left: 20px;
  pointer-events: none;
}

.inputfield-number2 {
  width: 155px;
  height: 36px;
  margin-top: 10px;
  /* UI Properties */
  border: 1px solid #888585;
  border-radius: 2px;
  opacity: 1;
  padding-left: 10px;
}
.divsn {
  justify-content: center;
  align-items: center;
  display: flex;
}

.submit {
  width: 92px;
  height: 36px;
  /* UI Properties */
  background: #0f2587 0% 0% no-repeat padding-box;
  border-radius: 2px;
  opacity: 1;
  color: #ffffff;
  margin-top: -7px;
  margin-left: 5px;
}

.q-tab {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.prediction-table {
  box-shadow: none;
  margin-top: 30px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px;
}

.prediction-table tr,
.prediction-table td {
  border-color: rgba(0, 0, 0, 0);
}

.prediction-table th {
  border-color: rgba(0, 0, 0, 0);
  background-color: rgb(232, 236, 240);
}

.btn {
  width: 110px !important;
}

.tooltip {
  font-size: 13px !important;
}

@media (max-width: 1400px) {
  .panel {
    margin-top: 50px;
  }

  .container1 {
    padding: 15px !important;
    margin: 0%;
  }
}

.refresh_button {
  cursor: pointer;
  width: 101px;
  height: 32px;
  background-color: #0f2587;
  color: white;
  display: flow-root;
  position: relative;
  top: -36px;
  left: 50rem;
}

.bg-colorbutton {
  background-color: #0f2587 !important;
}

.bg-notactive {
  background-color: #c5c3c3 !important;
}

.curr {
  align-items: center;
  justify-content: center;
  display: flex;
  margin-left: 20px;
  margin-top: 9px;
  margin-right: 3px;
  font-weight: bold;
}

.fit {
  border-top-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  background: white !important;
  box-shadow: 0px 3px 6px #00000030;
}

.q-checkbox__svg {
  color: blue !important;
}
</style>

<script>
import { ref } from "vue";

export default {
  data() {
    return {
      averageInput: "",
      storageType: "",
      selectInput: "",
      maxInput: "",
      isOpenSelect: false,
      icon: "keyboard_arrow_right",

      optionsArray: [
        "How much is for Easy Ship Capacity",
        "How much is you FBA Capacity",
      ],
      model: null,
      saveflag: false,
      savecheck: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      dynamic_url: "",
      asins: [],
      click: false,
      isDisable: false,
      click1: false,
      repricing1: false,
      revert1: false,
      asin_label: "Select ASIN",
      selected_asin: "Select or Enter your ASIN",
      enable_connect: false,
      product_id_reprice: 0,
      connect_now: {},
      hide_panel: {},
      datareprice: [],
      pass_data: [],
      pass_inventory: [],
      show_error: false,
      show_error_lead: false,
      upper_limit: 0,
      lower_limit: 0,
      max_lead: 0,
      datarevert: [],
      options: [],
      asin_price: "",
      tableStyle: {
        minWidth: "1000px", // set the minimum width of the table
      },
      asin_name: "",
      currency: "",
      img_url: "",
      resulttype: "",
      selected: [],
      check_all: false,
      backupList: [],
      backupList1: [],
      recommendedPrice: 0,
      currentPrice: 199,
      currentPrice1: 50,
      accepting_price: 50,
      repricingRow: "",
      show:true,
      errors: false,
      limit_set: false,
      row_data: [],
      data: [],
      data1: [],
      connected: "Connect Now",
      connectButtonVisible: true,
      filter: "",
      filter1: "",
      org_id: 0,
      columns: [
        { name: "select", label: "Select", align: "center", required: true },
        { name: "asin", label: "ASIN", align: "center", required: true },
        {
          name: "product",
          label: "Product Name",
          align: "left",
        },
        {
          name: "test",
          label: "test value1",
          align: "left",
        },
        {
          name: "test2",
          label: "test value2",
          align: "left",
        }
      ],
      tab: "app",
      count: 0,
      agree: false,
      pagination: {
        rowsPerPage: 4, // current rows per page being displayed
      },
      is_left_open: true,
      colWidth: true,
      //Price  Prediction tab data
      rows: [
        // {
        //     "product_name":"Mobile",
        //     "current_selling_price":"123",
        //     "predicted_buybox_price":"234",
        //     "suggested_discount":"5%",
        //     "reprice":"Reprice"
        // },
        // {
        //     "product_name":"Television",
        //     "current_selling_price":"238",
        //     "predicted_buybox_price":"294",
        //     "suggested_discount":"10%",
        //     "reprice":"Not"
        // },
        // {
        //     "product_name":"Refrigerator",
        //     "current_selling_price":"87",
        //     "predicted_buybox_price":"94",
        //     "suggested_discount":"8%",
        //     "reprice":"Reprice"
        // },
      ],
      columns1: [
        {
          name: "product_asin",
          field: "product_asin",
          label: "Product ASIN",
          align: "center",
          required: true,
        },
        {
          name: "current_selling_price",
          field: "current_selling_prices",
          label: "Current Selling Price",
          align: "center",
          required: true,
        },
        {
          name: "inventory",
          field: "inventory",
          label: "Current Inventory",
          align: "center",
          required: true,
        },
        {
          name: "stock_buffer",
          field: "stock_buffer",
          label: "Stock Buffer for next month",
          align: "center",
          required: true,
        },
        {
          name: "predicted_buybox_price",
          field: "predicted_buybox_price",
          label: "Predicted Buybox Price",
          align: "center",
          required: true,
        },
        {
          name: "update_timestamp",
          field: "update_timestamp",
          label: "Time of Prediction",
          align: "center",
          required: true,
        },
        {
          name: "reprice",
          field: "reprice",
          label: "Reprice Status",
          align: "center",
          required: true,
        },
      ],
    };
  },
  computed: {
    handleSaveChange() {
      //console.log(this.lower_limit);
      if (
        parseFloat(this.upper_limit) <= parseFloat(this.lower_limit) ||
        (this.lower_limit !== "" && this.upper_limit == "")
      ) {
        this.isDisable = true;
        this.show_error = true;
      } else {
        this.isDisable = false;
        this.show_error = false;
      }
      return "";
    },
    seller_api_URL() {
      return this.dynamic_url;
    },
    asin_img_url() {
      return this.img_url;
    },
    select_all() {
      this.count++;
      for (let i = 0; i < this.data.length; i++) {
        if (this.check_all) {
          this.data[i]["status"] = true;
        }
        if (this.count > 2 && this.check_all == false) {
          this.data[i]["status"] = false;
        }
      }
      return "";
    },
  },
  async created() {
    this.model = this.optionsArray[0];
    var currentUrl = window.location.href;
    var path = window.location.pathname;
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/amazonrepricer/qsmartsell/");
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    } else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
      this.$q.loading.show({
        message: "Loading your data please wait..",
      });
      localStorage.setItem("orgid", this.$org_id.label);
      var user_url =
        this.api_url + "/products/user_exists/" + this.$org_id.label;
      this.$http.post(user_url).then((response) => {
        if (response.data.length == 0) {
          var url = this.api_url + "/repricer/get_seller_api_url";
          this.$http
            .post(url)
            .then((response) => {
              this.dynamic_url = response.data;
              this.hide_panel = {
                "pointer-events": "none",
                opacity: "0.85",
              };
              this.$q.loading.hide();
            })
            .catch((err) => {
              this.$q.notify({
                message: err,
                color: "negative",
              });
            });
        } else {
          let URL =
            this.api_url + "/products/get_asins_details/" + this.$org_id.label;

          this.$http
            .post(URL)
            .then((response) => {
              let result = response;

              this.data = result.data;
              console.log('data',this.data)
              this.storageType =
                this.data[1][0].inventory_input_details.storage_type;
              this.averageInput =
                this.data[1][0].inventory_input_details.avg_lead_time;
              this.selectInput =
                this.data[1][0].inventory_input_details.fba_capacity;
              this.maxInput =
                this.data[1][0].inventory_input_details.max_lead_time;
              this.model =
                this.data[1][0].inventory_input_details.storage_type === "FBA"
                  ? this.optionsArray[1]
                  : this.optionsArray[0];
              this.backupList = result.data;
              this.$q.loading.hide();
              this.connected = "Connected";
              this.connectButtonVisible = false;
              this.connect_now = {
                "pointer-events": "none",
                opacity: "0.85",
              };
            })
            .catch((err) => {
              this.$q.notify({
                message: err,
                color: "negative",
              });
            });
        }
      });
  },
  mounted() {
    this.reloadpage();
  },
  methods: {
    repricer(){
      this.$mixpanel.track('Sales Optimization/Repricer/Repricer',{
        info: 'user Entered Repricer page'
      })
    },
    priceprediction(){
      this.$mixpanel.track('Sales Optimization/Repricer/PricePrediction',{
        info: 'user Entered priceprediction page'
      })

    },
    save_inventory(data, data1, data2, data3) {
      this.$mixpanel.track('Repricer/Saved',{
        info:'User Saved the changes'
      })
      if (this.savecheck === true) {
        this.save_price_limits();
        this.savecheck = false;
      }

      if (data1 < 0 || data1 > 1000) {
        data1 = 0;
      }
      if (data2 < 0 || data2 > 90) {
        data2 = 0;
      }
      if (data3 < 0 || data3 > 90) {
        data3 = 0;
      }
      this.pass_inventory = [
        {
          storage_type: data,
          avg_lead_time: parseFloat(data2),
          fba_capacity: parseFloat(data1),
          max_lead_time: parseFloat(data3),
        },
      ];
      let postURL =
        this.api_url + "/repricer/save_inventory_details/" + this.$org_id.label;
      this.$http.post(postURL, this.pass_inventory).then((response) => {
        // //console.log("DATA123", this.pass_data);
      });
      this.$alert("Submitted Succcesfully");
    },
    validateInput(value) {
      if (value < 0 || value > 90) {
        return "Lead Time must be between 0 and 90";
      }
      return true;
    },
    validateInput2(value) {
      if (value < 0 || value > 1000) {
        return "Lead Time must be between 0 and 1000";
      }
      return true;
    },
    toggleSelect() {
      this.isOpenSelect = !this.isOpenSelect;
    },
    selectOption(option) {
      if (option === this.model) {
        this.isOpenSelect = true;
        return;
      }

      // Set the new selected option
      this.model = option;

      if (this.storageType === "FBA") {
        this.storageType = "easy_ship";
      } else this.storageType = "FBA";

      // Remove the selected option from the list
      this.optionsArray = this.optionsArray.filter((item) => item !== option);

      // Add the previous selected option to the list
      this.optionsArray.push(this.model);

      // Close the dropdown

      this.isOpenSelect = true;
    },

    set_limit_true(row) {
      this.upper_limit = row.price_limit.upper_price;
      this.lower_limit = row.price_limit.lower_price;
      this.limit_set = true;
      this.row_data = row;
      this.savecheck = true;
    },
    passvalues(row) {
      row["price_limit"]["upper_price"] = this.upper_limit;
      row["price_limit"]["lower_price"] = this.lower_limit;
      if (
        parseFloat(this.upper_limit) <= parseFloat(this.lower_limit) ||
        (this.lower_limit !== "" && this.upper_limit == "")
      ) {
        this.isDisable = true;
      } else {
        this.pass_data.push(row);
        this.isDisable = false;
      }
    },

    post_price() {
      let lower_rate, upper_rate, prod_id;
      for (let i = 0; i < this.data.length; i++) {
        lower_rate = this.data[i].price_limit.lower_price;
        upper_rate = this.data[i].price_limit.upper_price;
        prod_id = this.data[i].id;
      }
      return [
        {
          id: prod_id,
          lower_price: lower_rate,
          upper_price: upper_rate,
        },
      ];
    },
    Modifyobject(obj) {
      let keys = ["id"];
      let filteredArray = obj.reduce((filtered, object) => {
        if (keys.every((key) => key in object)) {
          filtered.push(object);
        }
        return filtered;
      }, []);
      ////console.log("MODIFY", filteredArray);
    },
    save_price_limits() {
      let postURL = this.api_url + "/repricer/save_price_limits";
      this.$http.post(postURL, this.pass_data).then((response) => {
        // //console.log("ENTREED DATA");
        //console.log("DATA2345", this.pass_data);
      });
    },
    // mounted() {
    //   let data = localStorage.getItem("data");
    //   if (data) {
    //     this.data = JSON.parse(data);
    //   }
    // },
    refresh_asins() {
      // //console.log("hello" + this.data);
      // //console.log(typeof data);
      let URL =
        this.api_url + "/repricer/refresh_asinlist/" + this.$org_id.label;
      ////console.log(URL);
      this.$http
        .post(URL)
        .then((response) => {
          // let result = response;
          // //console.log(result);
          // this.$q.loading.hide();
          // this.$alert(
          //   "Successfully submitted your products for prediction",
          //   "Great!",
          //   "success"
          // );
        })
        .catch((error) => {
          //console.error(`onRejected function called: ${error.message}`);
        });
      window.location.reload();
    },
    get_label(asin) {
      this.asin_label = asin;
      this.selected_asin = asin;
      return asin;
    },
    searchHandler(value) {
      if (value.length >= 1) {
        let searchResult = this.backupList.filter((item) => {
          return item.asin.toLowerCase().includes(value.toLowerCase());
        });
        this.data = searchResult;
      } else {
        this.data = this.backupList;
      }
    },
    searchHandler1(value) {
      if (value.length >= 1) {
        let searchResult = this.backupList1.filter((item) => {
          return item.asin.toLowerCase().includes(value.toLowerCase());
        });
        this.rows = searchResult;
      } else {
        this.rows = this.backupList1;
      }
    },
    get_asin_details() {
      ////console.log("Showing data");
      this.$q.loading.show({
        message: "Loading ASIN data please wait..",
      });
      if (this.selected_asin == "Select or Enter your ASIN") {
        this.$alert(
          "Please select any ASIN and try again",
          "ASIN not selected!",
          "error"
        );
      } else {
        let URL =
          this.api_url + "/repricer/get_product_details/" + this.selected_asin;
        this.$http.post(URL).then((response) => {
          let result = response;
          this.asin_price =
            result.data.Price.CurrencyCode + " " + result.data.Price.Amount;
          this.asin_name = result.data.Name;
          this.img_url = result.data.Product_link;
          this.$q.loading.hide();
        });
      }
    },
    filterFn(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.options = this.asins.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    getStringBetween(str, start, end) {
      const result = str.match(new RegExp(start + "(.*)" + end));
      if (result == null) {
        return null;
      } else {
        return result[1];
      }
    },
    submit_asins() {
      this.$mixpanel.track('Repricer/Submit',{
        info:'user submitted ASIN for prediction'
      })
      this.$q.loading.show({
        message: "Submitting your products, please wait..",
      });
      ////console.log(this.data);
      let URL =
        this.api_url +
        "/products/update_asins_details/" +
        this.agree +
        "/" +
        this.$org_id.label;
      this.$http.post(URL, this.data).then((response) => {
        let result = response;
        ////console.log(result);
        this.$q.loading.hide();
        this.$alert(
          "Successfully submitted your products for prediction",
          "Great!",
          "success"
        );
      });
    },
    remove_select_all(status) {
      if (status == false) {
        this.check_all = false;
      }
    },
    reloadpage() {
      let URL =
        this.api_url + "/products/get_prediction_details/" + this.$org_id.label;
      this.$http.post(URL).then((response) => {
        let response1 = response.data;
        ////console.log(response.data[3].prediction_details.current_selling_price);
        let result = response1.map((items) => {
          return {
            ...items,
            expand: false,
            children: [],
          };
        });
        ////console.log("result", result);
        let prev_element = "";
        let curr_element = "";
        this.rows = [];
        for (let i = 0; i < result.length; i++) {
          curr_element = result[i].product_id;
          if (curr_element != prev_element) {
            this.rows.push(result[i]);
          } else {
            let l = this.rows.length;
            this.rows[l - 1].children.push(result[i]);
          }
          ////console.log("prev", prev_element);
          ////console.log("curr", curr_element);
          prev_element = curr_element;
        }
        this.backupList1 = this.rows;
        for (let i = 0; i < this.backupList1.length; i++) {
          if (
            !this.backupList1[i]["prediction_details"].hasOwnProperty(
              "inventory"
            )
          ) {
            let properties = this.backupList1[i];
            properties["inventory"] = undefined;
            properties["stock_buffer"] = undefined;
            this.backupList1[i] = properties;
          }
        }
        this.rows = this.backupList1;
        ////console.log("prediction results", this.rows);
      });
    },
    //Price prediction tab method
    //     async reprice(item){
    //         //console.log("item", item.prediction_details.current_selling_price);
    //         this.$confirm("This will update your current selling price to Recommended Selling Price","Are you sure to change this price?").then(() => {
    //         this.$q.loading.show({
    //         message: "Submitting your request, please wait..",
    //         });
    //       let data = {
    //         asin: item.asin,
    //         predicted_price: item.prediction_details.predicted_discount_price,
    //         prediction_id: item.id
    //       }
    //       //console.log("data",data);
    //       let URL = this.api_url + "/repricer/reprice";
    //         this.$http.post(URL,data).then((response) => {
    //             let result = response.data;
    //             //console.log(result);
    //             this.$alert("Successfully submitted your request","Great!", "success");
    //             this.$q.loading.hide();
    //         });
    //     });
    //     }
    //   },
    // };
    reprice(item) {
      console.log('item ', item)
      this.datareprice = item;
      this.currentPrice = item.price_limit.upper_price;
      this.accepting_price = item.price_limit.upper_price;
      this.repricing1 = true;
      this.product_id_reprice = item.product_id;
      ////console.log("item1", item);

      this.currency = "INR";
      // this.currentPrice ="INR" +" " +this.currentPrice;

      ////console.log("item", item.prediction_details.predicted_discount_price);
    },
    async repriceSubmit(datareprice) {
      ////console.log("SUBMIT", datareprice);
      const pricing= Math.abs((this.currentPrice - this.accepting_price) / this.currentPrice * 100);
      console.log("SUBMIT", this.currentPrice);
      console.log("SUBMIT accepting_price", this.accepting_price);
      console.log("SUBMIT", pricing);
      if (pricing > 10) {
        this.repricing1 = false;
        this.$alert("Price change attempted is more than 10%").then(() => {
          this.repricing1 = true;
          // Additional logic after the alert is closed
        });
      }

      else if (this.accepting_price < 2) {
        this.errors = true;
      } else {
        this.errors = false;
        this.$q.loading.show({
          message: "Submitting your request, please wait..",
        });
        this.resulttype = "reprice";
        let data = {
          asin: this.datareprice.asin,
          accepted_selling_price: this.accepting_price,
          prediction_id: this.datareprice.id,
          price_type: this.resulttype,
        };
        ////console.log("data", data);
        let URL = this.api_url + "/repricer/reprice/" + this.$org_id.label;
        this.$http.post(URL, data).then((response) => {
          let result = response.data;
          this.repricing1 = false;
          ////console.log(result);
          if (result === "FALSE") {
            this.$alert("Denied repricer action by admin");
            this.$q.loading.hide();
          } else if (result == "HBE") {
            this.$alert(
              "Please enter a price value lower than higher price limit"
            );
            this.$q.loading.hide();
          } else if (result == "LBE") {
            this.$alert(
              "Please enter a price value higher than lower price limit"
            );
            this.$q.loading.hide();
          } else if (result == "BNA") {
            this.$alert(
              "Change Boundary Not Accepted to Boundary Not Available",
              "Note : Please set upper and loweboundary values to complete reprice action"
            );
            this.$q.loading.hide();
          } else {
            this.$alert(
              "Successfully submitted your request",
              "Great!",
              "success"
            );
            this.$q.loading.hide();
            this.reloadpage();
          }
        });
      }
    },
    processing(){
      this.$mixpanel.track('PricePrediction/Processing',{
        info:'User clicked Processing'
      })
    },
    revert(item) {
      this.$mixpanel.track('Price Prediction/Revert',{
        info:'User Reverted the changes'
      })
      this.datarevert = item;
      this.revert1 = true;
      this.currentPrice1 = item.prediction_details.current_selling_price;
    },
    async revertSubmit(datarevert) {
      this.$q.loading.show({
        message: "Submitting your request, please wait..",
      });
      ////console.log("item1", this.datarevert);
      this.resulttype = "revert";
      let data = {
        asin: this.datarevert.asin,
        accepted_selling_price: this.currentPrice1,
        prediction_id: this.datarevert.id,
        price_type: this.resulttype,
        product_id: this.product_id_reprice,
      };
      ////console.log("data", data);
      let URL = this.api_url + "/repricer/reprice/" + this.$org_id.label;
      this.$http.post(URL, data).then((response) => {
        let result = response.data;
        this.revert1 = false;
        ////console.log(result);
        this.$alert("Successfully submitted your request", "Great!", "success");
        this.$q.loading.hide();
        this.reloadpage();
      });
    },
  },
};
</script>